import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  Heart,
  Award,
  Star,
  GraduationCap,
  ShieldCheck,
  MapPin,
  Menu,
} from "lucide-react";
import { useBookingPopup } from "@/hooks/use-booking-popup";
import { motion, useScroll, useTransform } from "framer-motion";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";

import { useLocation } from "react-router-dom";

const Header = () => {
  const { openPopup } = useBookingPopup();
  const location = useLocation();
  const isHome = location.pathname === "/";

  const navLinks = [
    { name: "HOME", path: "/" },
    { name: "ABOUT US", path: "/about" },
    { name: "PUPPY TRAINING", path: "/puppy-training" },
    { name: "1:1 TRAINING", path: "/1-1-training" },
    { name: "CLASSES", path: "/classes" },
    { name: "SCENT WORK", path: "/scent-work" },
    { name: "WALKING", path: "/walking" },
    { name: "PET SITS", path: "/pet-sits" },
    { name: "BLOG", path: "/blog" },
    { name: "CONTACT", path: "/contact" },
  ];

  return (
    <header className="w-full flex flex-col font-body sticky top-0 z-50">
      {/* Top CTA Bar */}
      <div className="bg-accent text-white py-2 px-4 text-sm flex justify-center items-center gap-2 font-bold tracking-wide text-lg font-body uppercase h-[44px]">
        No Judgement. Just Support. <Heart className="w-4 h-4" />
      </div>

      {/* Main Navigation */}
      <nav className="bg-white border-b h-[96px] flex items-center">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center max-w-7xl">
          <Link to="/" className="flex items-center gap-2">
            <img
              src="https://vibe.filesafe.space/1780604500184904220/attachments/b269428a-1e68-45f3-a350-7ebcb8f83069.png"
              alt="WagRight Dog Training"
              className="h-16 w-auto"
              fetchPriority="high"
              decoding="async"
            />
          </Link>

          <div className="hidden lg:flex items-center gap-3 xl:gap-5 font-bold text-[12px] xl:text-[13px] text-primary">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className="hover:text-accent transition-colors whitespace-nowrap"
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden lg:block">
            <Button
              onClick={openPopup}
              className="bg-primary hover:bg-primary/90 text-white font-bold rounded-sm px-6 py-6 whitespace-pre-line text-center leading-tight"
            >
              Book a Call
            </Button>
          </div>

          <Sheet>
            <SheetTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="flex lg:hidden items-center justify-center"
              >
                <Menu className="w-6 h-6" />
                <span className="sr-only">Toggle Menu</span>
              </Button>
            </SheetTrigger>
            <SheetContent
              side="right"
              className="w-[300px] sm:w-[400px] bg-white z-[100]"
            >
              <SheetHeader className="text-left">
                <SheetTitle className="font-display text-2xl text-primary">
                  MENU
                </SheetTitle>
              </SheetHeader>
              <div className="flex flex-col gap-6 mt-12">
                {navLinks.map((link) => (
                  <SheetTrigger asChild key={link.name}>
                    <Link
                      to={link.path}
                      className="text-xl font-bold text-primary hover:text-accent transition-colors"
                    >
                      {link.name}
                    </Link>
                  </SheetTrigger>
                ))}
                <SheetTrigger asChild>
                  <Button
                    onClick={() => {
                      openPopup();
                    }}
                    className="bg-primary hover:bg-primary/90 text-white font-bold rounded-sm py-8 text-lg mt-4"
                  >
                    Book a Call
                  </Button>
                </SheetTrigger>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </nav>
    </header>
  );
};

export default Header;
